import { ListItemIcon } from '@mui/material/';
import MenuItem from '@mui/material/MenuItem';
import { FC, ReactElement } from 'react';
import { ContextMenu } from '../menu';
import { useContextMenuService } from '../service';

export interface IContextMenuProps {
  children: ReactElement;
}

export const ContextMenuProvider: FC<IContextMenuProps> = props => {
  const { children } = props;
  const { contextMenuConfig, closeContextMenu } = useContextMenuService();

  return (
    <>
      {children}

      {contextMenuConfig && (
        <ContextMenu onClose={closeContextMenu} anchorEl={contextMenuConfig?.anchorEl || null}>
          {contextMenuConfig.items.map((config, index) => {
            const { id, icon, onClick, context, ...rest } = config;

            return (
              <MenuItem
                key={id}
                {...rest}
                data-testid={`context-menu-item-${id}`}
                onClick={() => onClick(context)}
                sx={{
                  px: 0.6,
                  fontSize: { xs: '13px', md: '14px' },
                  borderBottom: theme =>
                    contextMenuConfig.items.length - 1 === index ? 'none' : `1px solid ${theme.palette.divider}`,
                }}
              >
                <ListItemIcon>{icon}</ListItemIcon>
                {config.label}
              </MenuItem>
            );
          })}
        </ContextMenu>
      )}
    </>
  );
};
